import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {PropType, ref, watch} from 'vue';
import ArrowRightIcon from "@/components/Icons/components/ArrowRightIcon.vue";

type Variant = 'solo' | 'underlined' | 'outlined' | 'solo-filled' | 'solo-inverted' | undefined;


export default /*@__PURE__*/_defineComponent({
  __name: 'SelectDropdown',
  props: {
  modelValue: {
    type: [Object, String] as PropType<object | string>,
  },

  items: {
    type: Array as PropType<any[]>,
  },

  variant: {
    type: String as PropType<Variant>,
    default: 'underlined',
  },

  itemTitle: {
    type: String as PropType<string>,
    default: 'label',
  },

  itemValue: {
    type: String as PropType<string>,
    default: 'name',
  },

  disabled: {
    type: Boolean as PropType<boolean>,
    default: false,
  },

  readonly: {
    type: Boolean as PropType<boolean>,
    default: false,
  },

  returnObject: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const emit = __emit

const props = __props

const setSelect = ref(props.modelValue);

watch(() => props.modelValue, (value) => {
  setSelect.value = value;
});

watch(setSelect, (value) => {
  return emit('update:modelValue', value);
});

return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createBlock(_component_v_select, {
    items: __props.items,
    modelValue: setSelect.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((setSelect).value = $event)),
    variant: __props.variant,
    "item-title": __props.itemTitle,
    "item-value": __props.itemValue,
    disabled: __props.disabled,
    readonly: __props.readonly,
    "return-object": __props.returnObject,
    "single-line": "",
    menuIcon: ArrowRightIcon
  }, null, 8, ["items", "modelValue", "variant", "item-title", "item-value", "disabled", "readonly", "return-object"]))
}
}

})